import { authInstance, guestInstance } from '.';
import { IBookingRequestModel } from '../interfaces/requests/IBookingRequestModel';
import { IBookingResponseModel } from '../interfaces/responses/IBookingResponseModel';


export const getAllBookings = async (): Promise<IBookingResponseModel[] | string> => {
    try {
        const response = await authInstance.get('booking/getAll');
        return response.data;
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка при получении всех бронирований'];
    }
};

export const checkAvailability = async (
    bookings: IBookingRequestModel[]
): Promise<string | boolean> => {
    try {
        const response = await guestInstance.post('booking/checkTickets', bookings);
        if (response.data.success) {
            return true;
        } else {
            return response.data.message || 'Недостаточно доступных билетов';
        }
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка при проверке доступности билетов'];
    }
};

export const getBookingById = async (
    id: string
): Promise<IBookingResponseModel | string[]> => {
    try {
        const response = await authInstance.get(`booking/getById/${id}`);
        return response.data;
    } catch (e: any) {
        return e.response?.data?.errors || ['Ошибка при получении бронирования'];
    }
};

export const getBookingsByUserId = async (
    userId: string
): Promise<IBookingResponseModel[] | string[]> => {
    try {
        const response = await authInstance.get(`booking/getByUserId/${userId}`);
        return response.data;
    } catch (e: any) {
        return e.response?.data?.errors || ['Ошибка при получении бронирований'];
    }
};


export const deleteBooking = async (id: string): Promise<string> => {
    try {
        await authInstance.delete(`booking/delete/${id}`);
        return 'Бронирование успешно удалено';
    } catch (e: any) {
        return e.response?.data?.errors || 'Ошибка при удалении бронирования';
    }
};
